export default "__VITE_ASSET__DfDRaYoY__"